import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import '../../../src/style.css';
import '../PoDetails/PoDetails.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from 'axios';
import { API_URL,PDF_API_URL } from '../config'
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';
import Loader from '../Utils/AnLoader/Loader'
import { format } from 'date-fns';
export default class PoDetailsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            getAllData:[],
            orderDetails: [],
            orderDate: [],
            orderTerms: [],
            orderAdditionalDetails: [],
            orderAllowanceTaxInformation: [],
            orderTotalQty: [],
            latest_updated_at: [],
            latest_updated_by: [],
            selectedPDF: localStorage.getItem('SelectedPdf'),
            useName: sessionStorage.getItem('UserName'),
            selectedValue: "",
            ItemTotal: "",
            TotalQty: "",

        }

    }
    componentDidMount() {
        // Call handleGetRole when the component mounts
        // this.handleGetRole();
        var login = localStorage.getItem("token")
        if (login === null || login === undefined) window.location.href = "/";

        if (localStorage.getItem("SelectedValue")) {
            this.GetPodetails();
        }

    }
    GetPodetails(val) {
        debugger
        if (localStorage.getItem("SelectedValue")) {
            axios.get(API_URL + `/api/po-details/?order_number=${localStorage.getItem("SelectedValue")}`).then((res) => {
                if (res && res.data && res.data) {
                    let srno = 0 
                    res.data.order_additional_details.forEach(e => {
                    srno++
                              e.line_id = srno
                            });
                    this.setState({
                        getAllData:res.data,
                        
                        orderDetails: res.data.order_details,
                        orderDate: res.data.order_date,
                        orderTerms: res.data.order_terms[0],
                        orderAdditionalDetails: res.data.order_additional_details,
                        orderAllowanceTaxInformation: res.data.order_allowance_tax_information,
                        orderTotalQty: res.data.order_total_qty[0],
                        latest_updated_at: this.formatLatestUpdatedAt(res.data.latest_updated_at),
                        latest_updated_by: res.data.latest_updated_by,

                    });
                } else {
                    this.setState({
                        orderDetails: [],
                        orderDate: [],
                        orderTerms: [],
                        orderAdditionalDetails: [],
                        orderAllowanceTaxInformation: [],
                        orderTotalQty: [],
                        latest_updated_at: [],
                        latest_updated_by: []

                    });
                }
            })
        }
        else {
            axios.get(API_URL + `/api/po-details/?order_number=${val}`).then((res) => {
                if (res && res.data && res.data) {

                    this.setState({
                        orderDetails: res.data.order_details,
                        orderDate: res.data.order_date[0],
                        orderTerms: res.data.order_terms[0],
                        orderAdditionalDetails: res.data.order_additional_details,
                        orderAllowanceTaxInformation: res.data.order_allowance_tax_information,
                        orderTotalQty: res.data.order_total_qty[0],
                        latest_updated_at: this.formatLatestUpdatedAt(res.data.latest_updated_at),
                        latest_updated_by: res.data.latest_updated_by

                    });
                } else {
                    this.setState({
                        orderDetails: [],
                        orderDate: [],
                        orderTerms: [],
                        orderAdditionalDetails: [],
                        orderAllowanceTaxInformation: [],
                        orderTotalQty: [],
                        latest_updated_at: [],
                        latest_updated_by: []

                    });
                }
            })
        }
    }
    formatLatestUpdatedAt(dateString) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
        const formattedDate = new Date(dateString).toLocaleString('en-GB', options).replace(',', ''); // Remove comma
        return formattedDate;
    }
    handleClick = () => {
        window.location.href = '/PoDetailsEdit';
    }
    downloadPDF = () => {
        debugger
        this.setState({ loading: true });
    
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()} ${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')} ${currentDate.getHours() >= 12 ? 'PM' : 'AM'}`;
        
        const url = PDF_API_URL + `/export-po-details`;
        const requestData = {
            ...this.state.getAllData,
            
            ITEMTOTAL: this.state.ItemTotal,
            totalQty: this.state.TotalQty,
            currentDate: formattedDate // Add current date and time to requestData
        };
    
        // Replace null values with empty string in all arrays
        for (const key in requestData) {
            if (Array.isArray(requestData[key])) {
                requestData[key].forEach(item => {
                    for (const prop in item) {
                        if (item.hasOwnProperty(prop) && item[prop] === null) {
                            item[prop] = ''; // Replace null value with empty string
                        }
                    }
                });
            }
        }
    
        axios.post(url, requestData, { responseType: 'arraybuffer' }) // Ensure response is treated as an array buffer
            .then(async response => {
                if (response.status !== 200) {
                    throw new Error('Network response was not ok');
                }
    
                // Create PDF document
                const pdfDoc = await PDFDocument.load(response.data);
    
                // Convert PDFDocument to Uint8Array
                const pdfBytes = await pdfDoc.save();
    
                // Save the PDF to file
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                saveAs(blob, `PO-${this.state.orderDetails.order_name}.pdf`);
    
                // Hide loader
                this.setState({ loading: false });
    
                // Perform other actions after successful download
                this.getPoDetails();
                setTimeout(() => {
                    toast.success("PO Details Updated!");
                }, 2000);
                console.log('Update successful:', response.data);
            })
            .catch(error => {
                console.error('Error updating data:', error);
                // Hide loader in case of error
                this.setState({ loading: false });
            });
    };
    
    
    
    handleSelectChange = (selectedOption) => {
        
        localStorage.setItem('SelectedValue', selectedOption)
        if (selectedOption) this.GetPodetails(selectedOption);
        else {
            this.setState({
                orderDetails: [],
                orderDate: [],
                orderTerms: [],
                orderAdditionalDetails: [],
                orderAllowanceTaxInformation: [],
                orderTotalQty: [],
            });
        }
        this.setState({ selectedValue: selectedOption });

    };
    render() {
        const totalQty = this.state.orderAdditionalDetails.reduce((total, term) => total + parseFloat(term.qty), 0);

        const ITEMTOTAL = this.state.orderAdditionalDetails.reduce((item_total, term) => {
            const itemTotalNumber = parseFloat(term.item_total.replace(/[^\d.]/g, ''));

            if (itemTotalNumber !== null) {
                return item_total + parseFloat(itemTotalNumber);
            } else {
                return item_total;
            }
        }, 0).toFixed(2);
        
        this.state.ItemTotal = ITEMTOTAL 
        this.state.TotalQty = totalQty

        return (
            this.state.loading ? <Loader /> :
            <div className="container-fluid">
                <div className="row mt-2">
                    <div className="col-md-2">
                        <SideBar onSelectChange={this.handleSelectChange} poNumber={this.state.orderDetails.order_name} />

                    </div>
                    {(this.state.selectedValue || (localStorage.getItem("SelectedValue")) != "null" && (localStorage.getItem("SelectedValue")) != undefined) && (
                        <div className="col-md-10">
                            <div className="container mainCard h-100 HeadingTopMargin" style={{ backgroundColor: "#f9fbfd" }}>
                                <div className="row m-0 p-0 mb-3 align-items-center">
                                    <div className="col-md-6 col-12 mt-3">
                                        <h4 className='FontB'><b>PO {this.state.orderDetails.order_name}</b></h4>
                                    </div>
                                    <div className='col-md-6 text-end col-12 m-0 p-0'>
                                        <button className='btn-sm  buttonBorder' style={{ cursor: "pointer" }} onClick={this.handleClick}>
                                            Edit
                                        </button>
                                        <button className="btn-sm buttonBorder1G" onClick={this.downloadPDF} style={{ cursor: "pointer", color: 'white' }}>
                                            Export
                                        </button>
                                    </div>
                                </div>

                                <div className='cardPadding' id='downLoadPdf' style={{ background: "#F9FAFC", border: "2px solid black" }}>
                                    <div className='row'>
                                        <div className='row m-0 p-0'>
                                            <div className='col-md-6 col-12'>
                                                <span className="btn-sm PdfHeadingG">
                                                CHARU MERCHANDISING - FZCO
                                                </span>
                                            </div>
                                            <div className='col-md-6 col-12 text-end'>
                                                <span className='Font'>Date: </span>
                                                <span className='Font'>08/25/2024 03:45 PM</span>
                                            </div>
                                        </div>


                                        <div className='col-md-12 col-sm-6 d-flex mt-5 WebDiv'>
                                            <div className='col-md-6 p-2 col-sm-6  Font'>
                                                <span>Order: </span>
                                                <span>{this.state.orderDetails.order_name}</span><br />
                                                <span>Release: </span>
                                                <span>{this.state.orderDetails.release_details}</span><br />
                                                <span>PO Type: </span>
                                                <span>{this.state.orderDetails.po_type}</span><br />
                                                <span>Contract: </span>
                                                <span>{this.state.orderDetails.contract_name}</span><br />
                                                <span>Currency: </span>
                                                <span>{this.state.orderDetails.currency}</span><br />
                                                <span>Purchasing Contact: </span>
                                                <span>{this.state.orderDetails.purchasing_contact} </span><br />
                                                <span>Third Party reference: </span>
                                                <span>Charu Merchandising - FZCO</span><br />
                                            </div>
                                            <div className='col-md-6 col-sm-6 Font' >
                                                <div className='col-md-12 d-flex'>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>PO Date: </span><br />
                                                        <span>{this.state.orderDate.po_date ? format(new Date(this.state.orderDate.po_date), 'dd-MM-yyyy') : ""}</span>
                                                    </div>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Request. Delivery Date: </span><br />
                                                        {/* <span>{this.state.orderDate.req_delivery_date}</span> */}
                                                        <span>{this.state.orderDate.req_delivery_date ? format(new Date(this.state.orderDate.req_delivery_date), 'dd-MM-yyyy') : ""}</span>

                                                    </div>
                                                    
                                                </div>
                                                <div className='col-md-12 d-flex'>
                                                <div className='col-md-6 border p-1'  >
                                                        <span>Req. Ship Date: </span><br />
                                                        <span>{this.state.orderDate.req_ship_date ? format(new Date(this.state.orderDate.req_ship_date), 'dd-MM-yyyy') : ""}</span>

                                                    </div>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Cancel Date: </span><br />
                                                        <span>{this.state.orderDate.cancel_date ? format(new Date(this.state.orderDate.cancel_date), 'dd-MM-yyyy') : ""}</span>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 d-flex'>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Delivery Window: </span><br />
                                                        {/* <span>{this.state.orderDate.delivery_window}</span> */}
                                                        <span>{this.state.orderDate.delivery_window ? format(new Date(this.state.orderDate.delivery_window), 'dd-MM-yyyy') : ""}</span>
                                                        </div>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Shipping Window: </span><br />
                                                        {/* <span>{this.state.orderDate.shiping_window}</span> */}
                                                        <span>{this.state.orderDate.shiping_window ? format(new Date(this.state.orderDate.shiping_window.split(" - ")[0]), 'dd-MM-yyyy') + " - " + format(new Date(this.state.orderDate.shiping_window.split(" - ")[1]), 'dd-MM-yyyy') : ""}</span>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 d-flex'>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Vendor: </span><br />
                                                        <span>{this.state.orderDate.vendor}</span>
                                                    </div>
                                                    <div className='col-md-6 border p-1'  >
                                                        <span>Department: </span><br />
                                                        <span>{this.state.orderDate.department}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12 col-sm-6 mt-2 mobileDiv'>
                                            <div className='col-md-6 col-sm-6  Font'>
                                                <span>PO Date: </span>
                                                <span>{this.state.orderDate.po_date}</span><br />
                                                <span>Req. Ship Date: </span>
                                                <span>{this.state.orderDate.req_ship_date}</span><br />
                                                <span>Req. Delivery Date: </span>
                                                <span>{this.state.orderDate.req_delivery_date}</span><br />
                                                <span>Cancel Date: </span>
                                                <span>{this.state.orderDate.cancel_date}</span><br />
                                                <span>Delivery Window: </span>
                                                <span>{this.state.orderDate.delivery_window}</span><br />
                                                <span>Shipping Window: </span>
                                                <span>{this.state.orderDate.shiping_window}</span><br />
                                                <span>Order: </span>
                                                <span>{this.state.orderDetails.order_name}</span><br />
                                                <span>Release: </span>
                                                <span>{this.state.orderDetails.release_details}</span><br />
                                                <span>PO Type: </span>
                                                <span>{this.state.orderDetails.po_type}</span><br />
                                                <span>Contract: </span>
                                                <span>{this.state.orderDetails.contract_name}</span><br />
                                                <span>Currency: </span>
                                                <span>{this.state.orderDetails.currency}</span><br />
                                                <span>Purchasing Contact: </span>
                                                <span>{this.state.orderDetails.purchasing_contact} </span><br />
                                                <span>Third Party reference: </span>
                                                <span>Charu Merchandising - FZCO</span><br />
                                                
                                            </div>
                                            <div className='col-md-6 col-sm-6 Font' >

                                                <span>Vendor: </span>
                                                <span>{this.state.orderDate.vendor}</span><br />
                                                <span>Department: </span>
                                                <span>{this.state.orderDate.department}</span>

                                            </div>
                                        </div>
                                        <div className='card mt-3'>
                                            <div className='row d-flex pt-2'>
                                                <div className='col-md-3 border-1 '>
                                                    <span className='Font'>Ship To: </span>
                                                    <p className='Font'>{this.state.orderDetails.ship_to}</p><br />
                                                </div>
                                                <div className='col-md-3 border-1'>
                                                    <span className='Font'>Ship Bill To/Ordered By: </span>
                                                    <p className='Font'> Location ID: Charu Merchandising FZCO - IFZA BUSINESS PARK PREMISES NUMBER: 40685 – 001 A1 – 3641379065 DUBAI SILICON OASIS,DUBAI, UNITED ARAB EMIRATES</p><br />
                                                </div>
                                                <div className='col-md-3 border-1'>
                                                    <span className='Font'>Vendor: </span>
                                                    <p className='Font'>Location ID: 03235</p><br />
                                                </div>
                                                <div className='col-md-3 border-1'>
                                                    <span className='Font'>Factory: </span>
                                                    <span className='Font'>{this.state.orderDetails.factory_name}</span><br />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row'>
                                                <div className='col-sm-9'>
                                                    <span className='Font'>Freight Terms: </span><br />
                                                    <p className='FontB'><b>{this.state.orderTerms.freight_terms}</b></p>
                                                </div>
                                                <div className='col-sm-3'>
                                                    <span className='Font'>Preferred Carrier: </span>
                                                    <span><b>{this.state.orderTerms.preferred_carrier}</b></span>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-12 col-sm-12'>
                                                    <div style={{ overflowX: 'auto' }}>
                                                        <table className='table Font table-bordered'>
                                                            <thead>
                                                                <tr >
                                                                    <th>Terms Type: </th>
                                                                    <th>Terms Basis: </th>
                                                                    <th>Terms Disc %: </th>
                                                                    <th>Disc. Due Date: </th>
                                                                    <th>Disc. Days: </th>
                                                                    <th>Net Due Date: </th>
                                                                    <th>Net Days: </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className='Font'>
                                                                    <td>{this.state.orderTerms.terms_type}</td>
                                                                    <td>Auto Discount</td>
                                                                    <td>{this.state.orderTerms.terms_disc}</td>
                                                                    <td>{this.state.orderTerms.disc_due_date ? format(new Date(this.state.orderTerms.disc_due_date), 'dd-MM-yyyy') : ""}</td>
                                                                    <td>{this.state.orderTerms.disc_days}</td>
                                                                    <td>{this.state.orderTerms.net_due_date ? format(new Date(this.state.orderTerms.net_due_date), 'dd-MM-yyyy') : ""}</td>
                                                                    <td>{this.state.orderTerms.net_days}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-12 col-12 mb-5'>
                                                        <span className='Font'>Description: </span>
                                                        <span className='FontB'><b>{this.state.orderTerms.description}</b></span>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className='row m-0 p-0'>
                                                    <div className='col-md-12 col-sm-12'>
                                                        <div style={{ overflowX: 'auto' }}>
                                                            <table className='table table-bordered'>
                                                                <thead className='FontB'>
                                                                    <tr>
                                                                        <th>LINE</th>
                                                                        <th>SKU</th>
                                                                        <th>VENDOR PN</th>
                                                                        <th  style={{ minWidth: "150px" }}>UPC/GTIN</th>
                                                                        <th>DESCRIPTION LINE ITEM COMMENTS</th>
                                                                        <th>MARKS AND NUMBERS</th>
                                                                        <th>UNIT COST/ RETAIL PRICE</th>
                                                                        <th>QTY</th>
                                                                        <th>UOM</th>
                                                                        <th>ITEM TOTAL</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className='FontB'>
                                                                    {this.state.orderAdditionalDetails.map((term, index) => (

                                                                        <tr className='Font' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{term.sku}</td>
                                                                            <td>{term.vendor_pn}</td>
                                                                            <td>{term.upc_gstin}</td>
                                                                            <td>{term.desc_line_item_comment}</td>
                                                                            <td>{term.marks_and_numbers}</td>
                                                                            <td>{term.unit_price !== null ? term.unit_price : 0}</td>
                                                                            <td>{term.qty}</td>
                                                                            <td>{term.uom}</td>
                                                                            <td>{term.item_total}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot className='Font'>
                                                                    <tr>
                                                                        <td colSpan="7" style={{ textAlign: "right" }}>Merchandise Total</td>
                                                                        <td>{totalQty}</td>
                                                                        <td colSpan="1"></td>
                                                                        <td colSpan="1">{ITEMTOTAL}</td>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <span className='Font'>ALLOWANCE, CHARGES AND TAX INFORMATION: </span>
                                            </div>
                                            <hr />

                                            <div className='row'>
                                                <div className='col-md-12 col-sm-12'>
                                                    <div style={{ overflowX: 'auto' }}>
                                                        <table className='table table-bordered'>
                                                            <thead className='Font'>
                                                                <tr>
                                                                    <th>TYPE</th>
                                                                    <th>SERVICE TYPE</th>
                                                                    <th>PERCENT</th>
                                                                    <th>RATE</th>
                                                                    <th>QTY</th>
                                                                    <th>UMO</th>
                                                                    <th>DESCRIPTION</th>
                                                                    <th>AMOUNT</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody className='Font'>
                                                                <tr>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>

                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row Font'>
                                                <div className='col-md-12 col-sm-3'>
                                                    <span>Note/Comments/Special Instructions: {this.state.orderTotalQty.special_instructions}</span>
                                                </div>
                                                <div className='col-md-12'>
                                                    <span>Letters or Notes: {this.state.orderTotalQty.letter_notes}</span>
                                                </div>
                                                <div className='col-md-3'>
                                                    <span>Estimated Delivery: </span>
                                                    <span>{this.state.orderDate.estimated_delivery ? format(new Date(this.state.orderDate.estimated_delivery), 'dd-MM-yyyy') : ""}</span>

                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row Font m-0 p-0'>
                                                <div className='col-md-3' style={{border:"1px solid lightgray"}}>
                                                    <span>Total Qty: </span>
                                                    <span>{totalQty}</span>
                                                </div>
                                                <div className='col-md-3' style={{border:"1px solid lightgray"}}>
                                                    <span>Weight: </span>
                                                    <span className='FontB'><b>{this.state.orderTotalQty.weight}</b></span>
                                                </div>
                                                <div className='col-md-2' style={{border:"1px solid lightgray"}}>
                                                    <span>Volume: </span>
                                                    <span>{this.state.orderTotalQty.volumn}</span>
                                                </div>
                                                <div className='col-md-4' style={{border:"1px solid lightgray"}}>
                                                    <span>Purchase Order Total:</span>
                                                    <span className='FontB'><b>{ITEMTOTAL}</b></span>

                                                </div>
                                            </div>
                                            <hr className='mb-5' />
                                        </div>
                                    </div>

                                </div>

                                <div className='row mt-3 m-0 p-0'>
                                    <div className='col-md-12 col-12'>
                                        <span className='Font'>Last edited by <b>{this.state.latest_updated_by}</b> | Date: <b>{this.state.latest_updated_at}</b></span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}


                    {(this.state.selectedValue || (localStorage.getItem("SelectedValue")) != "null" && (localStorage.getItem("SelectedValue")) != undefined) ? null : (
                        <div className="col-md-10 text-center mt-5 p-5">
                            <div className="container mainCard h-100 p-5 " style={{ marginTop: "73px", backgroundColor: "#f9fbfd" }}>
                                <span className='Font mt-5'>To edit the PO invoice, Please first search for the PO document using the search bar.</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
